exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Landing-Home-___style__wrapper___9ZSdi .bg-white{background:#fff}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-Landing-Home-___style__wrapper___9ZSdi"
};